import { graphql } from 'react-relay';

/**
 * Resolves the page's attachment list so we can map a `media (type: "file")`
 * id to its filename — required to build the
 * `/wiki/download/attachments/{contentId}/{filename}` proxy URL that
 * `useFileMediaUrlSerializer` returns to `markdownModePlugin`.
 *
 * Schema mirrors the same selection used by
 * `editor-features/src/utils/fallbackMediaNameFetcher.ts`, the canonical
 * pre-existing query for "id → filename" lookups in the editor. Apollo
 * normalises the result, so when both queries run on the same page the
 * second is served entirely from cache.
 */
export const useFileMediaUrlSerializerQuery = graphql`
	query useFileMediaUrlSerializerQuery($contentId: ID!, $offset: Int, $first: Int) {
		content(id: $contentId, status: ["current", "draft"]) {
			edges {
				node {
					attachments(first: $first, offset: $offset) {
						nodes {
							title
							extensions {
								key
								value
							}
						}
						pageInfo {
							hasNextPage
						}
					}
				}
			}
		}
	}
`;
